import { Text, View, Image } from "@react-pdf/renderer";
import erpReady from "../images/erpReady.png";
import { useTranslation } from "react-i18next";

const Ecodesign = ({ styles, techData, heatRecovery }) => {
  const { t } = useTranslation();
  return (
    <View
      style={{
        ...styles["section-wrapper"],
        //marginTop: "5px",
      }}
      //break
      wrap={false}
    >
      <View style={styles.heading}>
        <Text style={styles.title}>
          {t("techCard.Ecodesign.Title").toUpperCase()}
        </Text>
      </View>
      <View style={styles["flex"]}>
        <View style={{ ...styles.left, paddingRight: "5px" }}>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.Ecodesign.Manufacturer")}:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.ecoDesignCalculation.manufacturer}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.Ecodesign.UnitModel")}:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.ecoDesignCalculation.unitModel}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.Ecodesign.Typology")}:
            </Text>
            <Text style={styles.value}>
              {/* {techData.calculation.ecoDesignCalculation.typology} */}
              NRVU / RVU
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles["wide-label"]}>
              SFPint / SFPint limit 2018 [W/m³/s]:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.ecoDesignCalculation.sfpInt} /{" "}
              {techData.calculation.ecoDesignCalculation.sfpIntLimit}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>{t("techCard.Ecodesign.HrsType")}:</Text>
            <Text style={styles.value}>
              {heatRecovery === "Rotary heat exchanger"
                ? t("techCard.Ecodesign.RotRecUnit")
                : t("techCard.Ecodesign.PlateRecUnit")}
            </Text>
          </View>
        </View>
        <View style={styles.right}>
          <View style={styles["md-flex"]}>
            <Text style={styles["wide-label"]}>
              {t("techCard.Ecodesign.ThermEff")} [%]:
            </Text>
            <Text style={styles.value}>
              {
                techData.calculation.summerRecCalculation
                  .sup_TemperatureEfficiency
              }
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.Ecodesign.CasLeakage")} -400Pa:
            </Text>
            <Text style={styles.value}>
              {/*
                techData.calculation.ecoDesignCalculation
                  .classOfCasingLeakageMinus
              */}{" "}
              N.A (R)
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.Ecodesign.CasLeakage")} +400Pa:
            </Text>
            <Text style={styles.value}>
              {/*
                techData.calculation.ecoDesignCalculation
                  .classOfCasingLeakagePlus
              */}{" "}
              N.A (R)
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.Ecodesign.MaxLeakage")} [%]:
            </Text>
            <Text style={styles.value}>
              {/*techData.calculation.ecoDesignCalculation.maxInternalLeakageRate*/}{" "}
              {/*0.10*/}
              N/A
            </Text>
          </View>
        </View>
      </View>

      <View style={styles["extras-left"]}>
        <View style={[styles.flex]}>
          <View
            style={{
              ...styles.left,
              paddingRight: "5px",
            }}
          >
            <View style={styles["md-flex"]}>
              <Text style={{ ...styles["wide-label"], fontWeight: 700 }}>
                {t("techCard.Casing.Title")}:
              </Text>
            </View>
            <View style={styles["md-flex"]}>
              <Text style={{ ...styles["wide-label"], fontWeight: 700 }}>
                {t("techCard.Casing.Explanation")}:
              </Text>
            </View>
            <View style={styles["md-flex"]}>
              <Text style={styles["wide-label"]}>
                {t("techCard.Casing.Standard")}:
              </Text>
            </View>
            <View style={styles["md-flex"]}>
              <Text style={styles.label}>
                {t("techCard.Ecodesign.ThermCond")}:
              </Text>
              <Text style={styles.value}>T2</Text>
            </View>
            <View style={styles["md-flex"]}>
              <Text style={styles.label}>
                {t("techCard.Ecodesign.ThermBrid")}:
              </Text>
              <Text style={styles.value}>TB2</Text>
            </View>
            <View style={styles["md-flex"]}>
              <Text style={styles["wide-label"]}>
                {t("techCard.Ecodesign.StructLeakage")} (-400 Pa) :
              </Text>
              <Text style={styles.value}>L1(M)</Text>
            </View>
            <View style={styles["md-flex"]}>
              <Text style={styles["wide-label"]}>
                {t("techCard.Ecodesign.StructLeakage")} (+700 Pa) :
              </Text>
              <Text style={styles.value}>L1(M)</Text>
            </View>
          </View>
          <View style={styles.right}>
            <View style={styles["md-flex"]}>
              <Text style={styles["wide-label"]}>
                {t("techCard.Ecodesign.MechStr")} (-1000 Pa):
              </Text>
              <Text style={styles.value}> D1(M)</Text>
            </View>
            <View style={styles["md-flex"]}>
              <Text style={styles["wide-label"]}>
                {t("techCard.Ecodesign.MechStr")} (+1000 Pa):
              </Text>
              <Text style={styles.value}>D1(M)</Text>
            </View>
            <View style={styles["md-flex"]}>
              <Text style={styles.label}>
                {t("techCard.Ecodesign.AirLeakage")} (400 Pa):
              </Text>
              <Text style={styles.value}>F9</Text>
            </View>
          </View>
        </View>
      </View>

      <View style={styles.extras}>
        <View style={[styles.flex, styles["no-pad"]]}>
          <View
            style={{
              ...styles.left,
              paddingRight: "5px",
              border: "none",
            }}
          >
            <View style={styles["md-flex"]}>
              <Text style={styles.white}>.</Text>
              <Text style={styles.white}>.</Text>
            </View>
            <View style={styles["md-flex"]}>
              <Text style={{ ...styles.label, width: "100%" }}>
                {t("techCard.Ecodesign.NomFlowRate")} [m³/s]:
              </Text>
            </View>
            <View style={styles["md-flex"]}>
              <Text style={{ ...styles.label, width: "100%" }}>
                {t("techCard.Ecodesign.TypeOfDrive")}:
              </Text>
            </View>
            <View style={styles["md-flex"]}>
              <Text style={{ ...styles.label, width: "100%" }}>
                {t("techCard.Ecodesign.EffElectPowerInput")} [Kw]:
              </Text>
            </View>
            <View style={styles["md-flex"]}>
              <Text style={{ ...styles.label, width: "100%" }}>
                {t("techCard.Ecodesign.FaceVelo")} [m/s]:
              </Text>
            </View>
            <View style={styles["md-flex"]}>
              <Text style={{ ...styles.label, width: "100%" }}>
                {t("techCard.Ecodesign.NomExtPress")} [Pa]:
              </Text>
            </View>
            <View style={styles["md-flex"]}>
              <Text style={{ ...styles.label, width: "100%" }}>
                {t("techCard.Ecodesign.IntPressDrop")} [Pa]:
              </Text>
            </View>
            <View style={styles["md-flex"]}>
              <Text style={{ ...styles.label, width: "100%" }}>
                {t("techCard.Ecodesign.StatEffFan")} [%]:
              </Text>
            </View>
            <View style={styles["md-flex"]}>
              <Text style={{ ...styles.label, width: "100%" }}>
                {t("techCard.Ecodesign.FilterEff")}:
              </Text>
            </View>
            <View style={styles["md-flex"]}>
              <Text style={{ ...styles.label, width: "100%" }}>
                {t("techCard.EnClass")}:
              </Text>
            </View>
          </View>
          <View style={styles["right-1"]}>
            <View
              style={{
                ...styles.col,
                justifyContent: "space-between",
              }}
            >
              <Text style={styles.value}>{t("techCard.Ecodesign.Supply")}</Text>
              <Text style={styles.value}>
                {(
                  techData.calculation.winterRecCalculation.sup_AirVolumeFlow /
                  3600
                ).toFixed(2)}
              </Text>
              <Text style={styles.value}>electronic speed control</Text>
              <Text style={styles.value}>
                {techData.calculation.supplyFanCalculation.powerInput}
              </Text>
              <Text style={styles.value}>
                {techData.calculation.ecoDesignCalculation.supFaceVelocity}
              </Text>
              <Text style={styles.value}>
                {techData.calculation.supplyFanCalculation.externalPressDrop}
              </Text>
              <Text style={styles.value}>
                {techData.calculation.supplyFanCalculation.internalPressDrop}
              </Text>
              <Text style={styles.value}>
                {techData.calculation.supplyFanCalculation.efficiency}
              </Text>
              <Text style={styles.value}>
                {techData.calculation.supplyFilterCalculation.classEN779}
              </Text>
              <Text style={styles.value}>
                {techData.calculation.euroventCalculation.energyClassWinter}
              </Text>
            </View>
            <View
              style={{
                ...styles.col,
                justifyContent: "space-between",
              }}
            >
              <Text style={styles.value}>
                {t("techCard.Ecodesign.Exhaust")}
              </Text>
              <Text style={styles.value}>
                {" "}
                {(
                  techData.calculation.winterRecCalculation.eha_AirVolumeFlow /
                  3600
                ).toFixed(2)}
              </Text>
              <Text style={styles.value}>electronic speed control</Text>
              <Text style={styles.value}>
                {techData.calculation.exhaustFanCalculation.powerInput}
              </Text>
              <Text style={styles.value}>
                {techData.calculation.ecoDesignCalculation.ehaFaceVelocity}
              </Text>
              <Text style={styles.value}>
                {techData.calculation.exhaustFanCalculation.externalPressDrop}
              </Text>
              <Text style={styles.value}>
                {techData.calculation.exhaustFanCalculation.internalPressDrop}
              </Text>
              <Text style={styles.value}>
                {techData.calculation.exhaustFanCalculation.efficiency}
              </Text>
              <Text style={styles.value}>
                {techData.calculation.exhaustFilterCalculation.classEN779}
              </Text>
              <Text style={styles.value}>
                {techData.calculation.euroventCalculation.energyClassWinter}
              </Text>
            </View>
          </View>
        </View>
      </View>
      <View style={{ ...styles.extras }}>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            // position: "relative",
          }}
        >
          <View>
            <Text>{t("techCard.Ecodesign.IntAddressText")}:</Text>
            <Text style={{ marginTop: "5px" }}>www.termovent.com</Text>
          </View>
          {parseFloat(techData.calculation.ecoDesignCalculation.sfpInt) <
          parseFloat(techData.calculation.ecoDesignCalculation.sfpIntLimit) ? (
            <View style={{ width: "130px" }}>
              <Image src={erpReady} alt="test" />
            </View>
          ) : (
            <></>
          )}
        </View>

        <View style={{ marginTop: "5px", textAlign: "center" }}>
          <Text>{t("techCard.Ecodesign.EcoSmallTitle")} 2018</Text>
        </View>
        <View style={{ marginTop: "5px", textAlign: "center" }}>
          <Text>{t("techCard.Ecodesign.EcoBottText")}</Text>
        </View>
      </View>
    </View>
  );
};

export default Ecodesign;
